const theme = {
  palette: {
    primary: {
      main: '#593672',
      dark: '#000000',
    },
    secondary: {
      main: '#F05D28',
      light: '#99A5B8',
    },
    background: {
      main: '#593672',
      light: '#F3F1FF',
      graylight: '#EFF2F8',
      lineardark: '#FF5A20',
      linearlight: '#FFA009',
      linearmenudark: '#421F5B',
      linearmenulight: '#6A4783',
    },
    border: {
      main: '#E8ECF4',
    },
    button: {
      color: '#FFF',
    },
    boxshadow: {
      main: 'rgba(213,91,44,.55)',
    },
  },
  sizes: {
    smalldesktop: 1200,
  },
};

export default theme;
